'use client';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export interface CategoryTabProps {
  category: CategoriesEntity;
  activeCategoryId?: number;
  setActiveCategoryId?: (id: number) => void;
  className?: {
    item?: string;
    isActive?: string;
    isInactive?: string;
  };
}

export function CategoryTab({
  category,
  activeCategoryId,
  setActiveCategoryId,
  className,
}: CategoryTabProps) {
  const isActive = activeCategoryId === category.id;

  return (
    <button
      type="button"
      aria-pressed={isActive}
      onClick={() => setActiveCategoryId?.(category.id!)}
      className={cn(
        'col-span-1 flex h-8 w-full items-center justify-center whitespace-nowrap px-4 text-sm font-medium transition-all sm:w-fit',
        isActive
          ? 'cursor-context-menu bg-black text-white'
          : 'cursor-pointer bg-transparent text-black hover:bg-black/[0.03]',
        className?.item,
        isActive ? className?.isActive : className?.isInactive,
      )}
    >
      {category.name}
    </button>
  );
}
